
export const filterConstants = {
  FILTER_WORK_REQUEST: 'FILTER_WORK_REQUEST',
  FILTER_WORK_REQUEST_SUCCESS: 'FILTER_WORK_REQUEST_SUCCESS',
  FILTER_WORK_REQUEST_ERROR: 'FILTER_WORK_REQUEST_ERROR'
}
